import React from 'react';
import { useParams } from 'react-router-dom';

import { CONTRACT_ACTIONS, ContractActions } from '../contract-actions';

const LineHistoryActions = () => {
  const { contractHeaderId, contractLineId } = useParams();

  return (
    <ContractActions
      actions={[
        CONTRACT_ACTIONS.VIEW_CONTRACT,
        CONTRACT_ACTIONS.VIEW_LATEST_CONTRACT_LINE_VERSION,
        CONTRACT_ACTIONS.VIEW_CONTRACT_LINE_LISTING,
      ]}
      contractHeaderId={contractHeaderId}
      contractLineId={contractLineId}
    />
  );
};

export default LineHistoryActions;
